// API Configuration
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const BASE_URL = API_BASE_URL.replace('/api', '');
export const config = {
    apiUrl: API_BASE_URL,
    baseUrl: BASE_URL,
    uploadsUrl: `${BASE_URL}/uploads`,
    certificatesUrl: `${BASE_URL}/certificates`,
    logoUrl: `${BASE_URL}/uploads/logos`,
};

export default config;
